(function () {
  const DEBUG = true;
  const log = (...args) => {
    if (DEBUG) console.log('[slate-sign-pdp]', ...args);
  };

  function init(root) {
    if (!root || root.dataset.slatePdpInit === 'true') return;
    root.dataset.slatePdpInit = 'true';

    const mainImg = root.querySelector('[id^="main-img-"]');
    const thumbs = root.querySelectorAll('[data-slate-thumb]');
    const sizeInputs = root.querySelectorAll('[data-slate-size]');
    const variantInput = root.querySelector('[data-slate-variant-id]');
    const priceEl = root.querySelector('[data-slate-price]');
    const sizeSub = root.querySelector('[data-size-sub]');
    const sizeProp = root.querySelector('[data-slate-size-property]');
    const qtyInput = root.querySelector('[data-slate-qty-input]');
    const qtyDisplay = root.querySelector('[data-qty-display]');
    const notesInput = root.querySelector('[data-notes-input]');
    const notesCounter = root.querySelector('[data-notes-counter]');
    const lineInputs = root.querySelectorAll('[data-line-input]');
    const fontInputs = root.querySelectorAll('input[name="properties[Font]"]');
    const productType = root.dataset.productType || 'personalised';

    const wishlistBtn = root.querySelector('[data-slate-wishlist-btn]');
    const wishlistIcon = root.querySelector('[data-slate-wishlist-icon]');
    const wishlistLabel = root.querySelector('[data-slate-wishlist-label]');
    const defaultWishlistLabel = (wishlistLabel?.textContent || 'Save for later').trim();
    const wishlistStorageKey = 'etchfyWishlistProducts';

    const productId = String(root.dataset.productId || '');
    const productHandle = root.dataset.productHandle || '';
    const productTitle = root.dataset.productTitle || '';
    const productUrl = root.dataset.productUrl || '';
    const productImage = root.dataset.productImage || '';

    let limits = { default: 25 };
    try {
      limits = JSON.parse(root.dataset.charLimits || '{"default":25}');
    } catch (e) {}

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        thumbs.forEach((t) => t.classList.remove('active'));
        thumb.classList.add('active');
        if (!mainImg) return;
        const src = thumb.dataset.full;
        if (src) mainImg.src = src;
        mainImg.alt = thumb.dataset.alt || '';
      });
    });

    function applyVariant(input) {
      if (!input) return;
      if (variantInput) variantInput.value = input.value;
      if (priceEl) priceEl.textContent = input.dataset.price || '';
      if (sizeSub) {
        const title = input.dataset.title || '';
        const length = input.dataset.length || '';
        sizeSub.textContent = title && length ? title + ' · ' + length : (title || length);
      }
      if (sizeProp) sizeProp.value = input.dataset.length || input.value;
    }
    sizeInputs.forEach((input) => input.addEventListener('change', () => applyVariant(input)));
    applyVariant(root.querySelector('[data-slate-size]:checked') || sizeInputs[0]);

    function updateCounters() {
      lineInputs.forEach((input) => {
        const index = input.dataset.lineInput;
        const counter = root.querySelector('[data-char-counter="' + index + '"]');
        const max = lineCharMax(input);
        if (counter) counter.innerHTML = input.value.length + ' / <span class="limit-val">' + max + '</span>';
      });
    }

    function lineCharMax(input) {
      const fontKey = (root.querySelector('input[name="properties[Font]"]:checked')?.value || 'default')
        .toLowerCase()
        .replace(/\s+/g, '_');
      const fontMax = parseInt(limits[fontKey] || limits.default || 25, 10);
      const lineMax = parseInt(input.dataset.lineMax || '25', 10);
      return Math.min(fontMax, lineMax);
    }

    function applyCharLimits() {
      lineInputs.forEach((input) => {
        const max = lineCharMax(input);
        input.setAttribute('maxlength', String(max));
        if (input.value.length > max) input.value = input.value.slice(0, max);
      });
      updateCounters();
    }
    fontInputs.forEach((input) => input.addEventListener('change', applyCharLimits));
    lineInputs.forEach((input) => input.addEventListener('input', updateCounters));

    if (productType === 'non-personalised') {
      root.querySelector('#section-fonts')?.classList.add('is-hidden');
      root.querySelector('#section-text-fields')?.classList.add('is-hidden');
      root.querySelector('#section-formatting-note')?.classList.add('is-hidden');
      root.querySelector('#section-upload-prompt')?.classList.add('is-hidden');
      lineInputs.forEach((input) => {
        input.disabled = true;
        input.removeAttribute('required');
      });
      fontInputs.forEach((input) => {
        input.disabled = true;
      });
    } else if (productType !== 'fully-custom') {
      root.querySelector('#section-upload-prompt')?.classList.add('is-hidden');
    }

    const productFormEl = root.querySelector('product-form');
    const cartForm = root.querySelector('form[data-type="add-to-cart-form"]');
    const formErrorWrapper = productFormEl?.querySelector('.product-form__error-message-wrapper');
    const formErrorMessage = productFormEl?.querySelector('.product-form__error-message');

    function getLineDebugInfo(input) {
      return {
        line: input.dataset.lineInput,
        name: input.name,
        value: input.value,
        dataLineRequired: input.dataset.lineRequired,
        hasRequiredAttr: input.hasAttribute('required'),
        debugRequired: input.dataset.debugRequired,
        debugOptional: input.dataset.debugOptional,
        debugRequiredMfBlank: input.dataset.debugRequiredMfBlank,
        debugOptionalMfBlank: input.dataset.debugOptionalMfBlank,
        debugRequiredRaw: input.dataset.debugRequiredRaw,
        debugOptionalRaw: input.dataset.debugOptionalRaw,
        isLineRequired: input.dataset.lineRequired === 'true',
        valueTrimEmpty: !input.value.trim(),
      };
    }

    function logLineInputsState(label) {
      log(label, {
        productType,
        linesCount: root.dataset.linesCount,
        lineInputCount: lineInputs.length,
        formNovalidate: cartForm?.hasAttribute('novalidate'),
        lines: Array.from(lineInputs).map(getLineDebugInfo),
      });
    }

    function isLineRequired(input) {
      return input.dataset.lineRequired === 'true';
    }

    function showLineValidationError(message, invalidInput) {
      log('validation BLOCKED', { message, invalid: getLineDebugInfo(invalidInput) });
      lineInputs.forEach((input) => input.classList.remove('error'));
      if (invalidInput) {
        invalidInput.classList.add('error');
        invalidInput.focus({ preventScroll: false });
        const lineNum = invalidInput.dataset.lineInput || '1';
        invalidInput.setCustomValidity('Please enter Line ' + lineNum + '.');
        invalidInput.reportValidity();
        invalidInput.setCustomValidity('');
      }
      if (formErrorWrapper && formErrorMessage) {
        formErrorWrapper.hidden = false;
        formErrorMessage.textContent = message;
      }
    }

    function clearLineValidationError() {
      lineInputs.forEach((input) => input.classList.remove('error'));
      if (formErrorWrapper) formErrorWrapper.hidden = true;
      if (formErrorMessage) formErrorMessage.textContent = '';
    }

    function validateRequiredLines() {
      if (productType === 'non-personalised') {
        log('validateRequiredLines: skipped (non-personalised)');
        return true;
      }

      let firstInvalid = null;
      const checks = [];

      lineInputs.forEach((input) => {
        const required = isLineRequired(input);
        const empty = !input.value.trim();
        const fails = required && empty;
        checks.push({ ...getLineDebugInfo(input), required, empty, fails });
        if (fails) firstInvalid = firstInvalid || input;
      });

      log('validateRequiredLines', { checks, blocked: !!firstInvalid });

      if (!firstInvalid) return true;

      showLineValidationError('Please fill in all required personalisation lines.', firstInvalid);
      return false;
    }

    cartForm?.addEventListener(
      'submit',
      (evt) => {
        log('submit (capture)', { defaultPrevented: evt.defaultPrevented });
        logLineInputsState('on submit');
        const valid = validateRequiredLines();
        if (!valid) {
          log('submit STOPPED by slate-sign validation');
          evt.preventDefault();
          evt.stopImmediatePropagation();
        } else {
          log('submit ALLOWED by slate-sign validation');
        }
      },
      true
    );

    cartForm?.addEventListener(
      'submit',
      (evt) => {
        log('submit (bubble)', { defaultPrevented: evt.defaultPrevented });
      },
      false
    );

    lineInputs.forEach((input) => {
      input.addEventListener('input', () => {
        input.classList.remove('error');
        const hasEmptyRequired = Array.from(lineInputs).some(
          (el) => isLineRequired(el) && !el.value.trim()
        );
        if (!hasEmptyRequired) clearLineValidationError();
      });
    });

    function updateNotesCounter() {
      if (!notesInput || !notesCounter) return;
      notesCounter.textContent = notesInput.value.length + ' / 250';
    }
    notesInput?.addEventListener('input', updateNotesCounter);

    function syncQty() {
      if (!qtyInput || !qtyDisplay) return;
      let q = parseInt(qtyInput.value || '1', 10);
      if (Number.isNaN(q) || q < 1) q = 1;
      qtyInput.value = String(q);
      qtyDisplay.textContent = String(q);
    }
    root.querySelector('[data-qty-minus]')?.addEventListener('click', () => {
      if (!qtyInput) return;
      qtyInput.value = String(Math.max(1, (parseInt(qtyInput.value || '1', 10) - 1)));
      syncQty();
    });
    root.querySelector('[data-qty-plus]')?.addEventListener('click', () => {
      if (!qtyInput) return;
      qtyInput.value = String(Math.max(1, (parseInt(qtyInput.value || '1', 10) + 1)));
      syncQty();
    });

    function getWishlistItems() {
      try {
        const parsed = JSON.parse(localStorage.getItem(wishlistStorageKey) || '[]');
        return Array.isArray(parsed) ? parsed : [];
      } catch (e) {
        return [];
      }
    }
    function setWishlistItems(items) {
      localStorage.setItem(wishlistStorageKey, JSON.stringify(items));
    }
    function isWishlisted(items) {
      return items.some((item) => String(item.id) === productId);
    }
    function renderWishlist(saved) {
      if (!wishlistBtn) return;
      wishlistBtn.classList.toggle('is-active', saved);
      wishlistBtn.setAttribute('aria-pressed', saved ? 'true' : 'false');
      if (wishlistIcon) wishlistIcon.textContent = saved ? '♥' : '♡';
      if (wishlistLabel) wishlistLabel.textContent = saved ? 'Saved' : defaultWishlistLabel;
    }
    wishlistBtn?.addEventListener('click', () => {
      if (!productId) return;
      const items = getWishlistItems();
      const saved = isWishlisted(items);
      if (saved) {
        setWishlistItems(items.filter((item) => String(item.id) !== productId));
        renderWishlist(false);
      } else {
        items.push({ id: productId, handle: productHandle, title: productTitle, url: productUrl, image: productImage });
        setWishlistItems(items);
        renderWishlist(true);
      }
    });

    applyCharLimits();
    updateCounters();
    updateNotesCounter();
    syncQty();
    renderWishlist(isWishlisted(getWishlistItems()));

    log('init', { productId, productHandle, productType });
    logLineInputsState('on init');

    if (cartForm && !cartForm.hasAttribute('novalidate')) {
      log('WARN: form missing novalidate — browser may validate required fields before our handler');
    }
  }

  document.querySelectorAll('[data-slate-pdp]').forEach(init);
})();
